import * as React from 'react';
const { useCallback } = React;
import Drawer from '@seeneco-ui/core/components/drawer';
import ConfirmDialog from '@seeneco-ui/core/components/confirm-dialog'


type ConfigForm = {
	account: ExternalSystemAccount;
	onRemove: (ID: number) => void;
}

type RemoveExternalSystemAccountFormProps = {
	onClose: () => void;
} & ConfigForm;

const RemoveExternalSystemAccountForm: React.SFC<RemoveExternalSystemAccountFormProps> = ({ account, onRemove, onClose }) => {
	const title = account.Name
		? `Вы точно хотите удалить аккаунт «${account.Name}»?`
		: 'Вы точно хотите удалить аккаунт?';
	const handleRemoveAccount = useCallback(() => {
		onRemove(account.ID);
		onClose();
	}, []);

	return (
		<ConfirmDialog
			title={title}
			actionLabel='Удалить'
			onAction={handleRemoveAccount}
			onClose={onClose}
		/>
	);
}

function openRemoveExternalSystemAccountFormDrawer(config: ConfigForm) {
	const handleClose =() => Drawer.default.get().close();

	Drawer.default.get().open({
		header:
			<Drawer.default.Title>
				Подтвердите удаление аккаунта
			</Drawer.default.Title>,
		content: <RemoveExternalSystemAccountForm {...config} onClose={handleClose} />,
		footer: null
	});
}

export {
	RemoveExternalSystemAccountForm,
	openRemoveExternalSystemAccountFormDrawer
};
export default RemoveExternalSystemAccountForm;
